export class Guid {
  static Empty = '00000000-0000-0000-0000-000000000000';

  /** Generates a new client side GUID.
   *  Reference: https://stackoverflow.com/a/26502275/7355697.
   */
  /* eslint-disable no-bitwise */
  static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}
